module.exports = __webpack_public_path__ + "static/media/bg.1a0656dc.png";